import { hideSearch } from "./search";
import { ResetMegaMenu } from "./megamenu";
import { ResetMainMenu } from "./menu";

/**
 * Megamenu
 * Use: import { initTopMenu } from "./components/top-menu";
 */
export function initTopMenu() {
	const TopNavItem = $('#menu-top-navigation .menu-item, #menu-language-navigation .menu-item');

	TopNavItem.on("mouseover", function(){
		ResetMainMenu();
		ResetMegaMenu();
	});
}